import React, { useEffect, useState, useRef } from "react";
import { Image } from "react-bootstrap";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import profileStyle from "./updateprofile.module.css";

import Edit from "./Edit/Edit";
import { useCookies } from "../../../hooks/useCookies";
import ProfileDetailsPreview from "./Preview/previewmain";
import Sidebar from "../../userflow/components/sidebar/sidebar";
import questionmark from "../../../assets/images/questionmark.png";
import { useProfile } from "../../userflow/components/context/ProfileContext";

const UpdateProfile = () => {
  const { profile } = useProfile();
  const isFetched = useRef(false);
  const [activeTab, setActiveTab] = useState("edit");
  const [showInfo, setShowInfo] = useState(false);
  const [value, setValue] = useState(0);

  const { getCookie } = useCookies();
  const token = getCookie("token");


  const toggleInfoVisibility = () => {
    setShowInfo(!showInfo);
  };

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    if (!token) return;
    // setData(profile);
  }, [profile, token]);

  const handleChange = (event, newValue) => {
    setActiveTab("preview")
    setValue(newValue);
  };
  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          padding: "16px",
          height: "calc(100vh - 64px)",
          width: "100%",
          scrollbarWidth: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <p className={profileStyle.componentname}>My Profile</p>
          <Image
            onClick={toggleInfoVisibility}
            style={{ cursor: "pointer" }}
            width="24px"
            height="24px"
            src={questionmark}
          />
          {showInfo && (
            <div className={`${profileStyle.whyInfo} ${profileStyle.show}`}>
              <p>
                Please note that changes to your photos and written prompts will
                be reviewed by our admin team before going live. This process
                may take up to 48 hours, but you can continue using your account
                without interruptions while we review & approve your updates.
              </p>
            </div>
          )}
        </div>
        {/* <div> */}
        <div>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="disabled tabs example"
            centered
          >
            <Tab
              className={`${profileStyle.tab} ${activeTab === "edit" ? profileStyle.active : ""
                }`}
              sx={{
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: "600",
                lineHeight: "27px",
                textAlign: "center",
                color: "#515151",
              }}
              label="Edit"
            />
            <Tab
              className={`${profileStyle.tab} ${activeTab === "preview" ? profileStyle.active : ""
                }`}
              sx={{
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: "600",
                lineHeight: "27px",
                textAlign: "center",
                color: "#515151",
              }}
              label="Preview"
            />
          </Tabs>
        </div>
        {value === 0 && <Edit />}
        {value === 1 && (
          <div
            style={{
              flex: 1,
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              overflowY: "auto",
              alignItems: "center",
            }}
          >
            <div style={{ overflowY: "scroll", scrollbarWidth: "none" }}>
              <div style={{ marginTop: "10px" }}>
                <ProfileDetailsPreview activeTabs={activeTab} />
              </div>
            </div>
          </div>
        )}
      </div>
    </Sidebar>
  );
};

export default UpdateProfile;
